/******************************************************************
 * ##: Geolocation permission state
 * Reads the current geolocation permission via the Permissions API, so the app can
 * report whether the user has granted, denied or not yet answered the prompt, even
 * when no position is available.
 *
 * TL;DR: "granted" | "denied" | "prompt" | "unavailable" | "unknown".
 * History:
 * 23-07-2026: Created
 ******************************************************************/

export const GEO_PERMISSION = {
  GRANTED: "granted",
  DENIED: "denied",
  PROMPT: "prompt",
  UNAVAILABLE: "unavailable",
  UNKNOWN: "unknown",
};

/**
 * Query the current geolocation permission state. Never throws.
 * @returns {Promise<string>} One of GEO_PERMISSION.*
 */
export const getGeolocationPermissionState = async () => {
  try {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      return GEO_PERMISSION.UNAVAILABLE;
    }
    if (navigator.permissions && typeof navigator.permissions.query === "function") {
      const result = await navigator.permissions.query({ name: "geolocation" });
      return result?.state || GEO_PERMISSION.UNKNOWN;
    }
    return GEO_PERMISSION.UNKNOWN;
  } catch (error) {
    return GEO_PERMISSION.UNKNOWN;
  }
};
